import instacart from 'legacy/common/instacart'
import { type DateRange } from 'legacy/common/utils/time/dateRanges.types'
import { dateToStringFormat } from 'legacy/common/utils/time/dateFormat'
import {
  type OrderSource,
  type OrderType,
  type OrderStatus,
} from 'legacy/sections/orders/utils/orders.types'
import { type OrdersListApiResponse } from 'legacy/sections/orders/components/list/utils/ordersList.types'
import { type DateSelectRangeValueType } from 'legacy/dash-components/date-select-range/utils/dateSelectRange.types'
import { type RetailerLocationSelectValueType } from 'legacy/dash-components/retailer-location-select/utils/options.types'
import { compactNullObject } from 'utils/objects/compact'
import { limitOffsetToPage } from 'legacy/common/utils/pagination/pagination.utils'

export interface OrdersListApiFetchOrdersProps {
  partnerId: string
  retailerId: string
  orderType: OrderType
  limit: number
  offset: number
  orderNumber?: string
  orderStatus?: OrderStatus
  orderSource?: OrderSource
  dateSelectRangeValue?: DateSelectRangeValueType
  retailerLocationSelectValue?: RetailerLocationSelectValueType
}

interface FetchOrdersQueryParams {
  // Not sure why we made the API this way...
  // Will need to be updated to a bool in the future
  isPickup: '0' | '1'
  isScanAndPay: '0' | '1'
  timeRange?: DateRange
  startDate?: string
  endDate?: string
  page?: number
  status?: OrderStatus
  orderSource?: OrderSource
  store_group_id?: string
  retailer_location_ids?: ReadonlyArray<string>
  order_ids?: ReadonlyArray<string>
}

export const ordersListApiFetchOrders = async ({
  partnerId,
  retailerId,
  orderType,
  orderNumber,
  orderStatus,
  orderSource,
  dateSelectRangeValue,
  retailerLocationSelectValue,
  limit,
  offset,
}: OrdersListApiFetchOrdersProps) => {
  const page = limitOffsetToPage({ limit, offset })
  const isPickup = orderType === 'pickup'
  const isScanAndPay = orderType === 'scan_and_pay'
  const dateRange = dateSelectRangeValue ? dateSelectRangeValue.dateRange : undefined
  const customDates = dateSelectRangeValue && dateSelectRangeValue.customDates
  const customStartDate = (customDates && customDates.startDate) || undefined
  const customEndDate = (customDates && customDates.endDate) || undefined
  const storeGroupId =
    (retailerLocationSelectValue && retailerLocationSelectValue.storeGroupId) || undefined
  const retailerLocationId =
    retailerLocationSelectValue && retailerLocationSelectValue.retailerLocationId

  const query: FetchOrdersQueryParams = compactNullObject({
    isPickup: isPickup ? '1' : '0',
    isScanAndPay: isScanAndPay ? '1' : '0',
    timeRange: dateRange,
    startDate: customStartDate ? dateToStringFormat(customStartDate) : undefined,
    endDate: customEndDate ? dateToStringFormat(customEndDate) : undefined,
    status: orderStatus,
    page,
    orderSource,

    store_group_id: storeGroupId,

    retailer_location_ids: retailerLocationId ? [retailerLocationId] : undefined,

    order_ids: orderNumber ? [orderNumber] : undefined,
  })

  return instacart.go.get<OrdersListApiResponse, FetchOrdersQueryParams>(
    `/v1/partners/${partnerId}/warehouses/${retailerId}/order_deliveries`,
    {
      query,
    }
  )
}
